<!-- page content start -->
<ion-header *ngIf="!pricepilot" class="header -primary" mode="md">
  <ion-toolbar color="primary" mode="md">
    <ion-title class="title-padding title-padding-on-large" ngslot="start"><img src="../../assets/logo_table42.svg"></ion-title>
  
    

    <ion-buttons slot="end">
  
      <!--<ion-button>
        <ion-icon class="profile"></ion-icon>
      </ion-button>-->

        <!--ion-select interface="action-sheet" [selectedText]="translateService.currentLang.toUpperCase()" style="padding-left:5px; max-width:100%; color: white; font-size: small;" [ngModel]="translateService.currentLang" (ionChange)="onChange($event)">
        <ion-select-option value="sl">SL - Slovenščina</ion-select-option>
        <ion-select-option value="en">EN - English</ion-select-option>
        <ion-select-option value="de">DE - Deutsch</ion-select-option>
        <ion-select-option value="it">IT - Italiano</ion-select-option>
        </ion-select-->

        <ion-menu-button slot="end" autoHide="false" color="light"></ion-menu-button>

      <!--<ion-button (click)="logout($event)">Odjava</ion-button>-->

      

      </ion-buttons>

  </ion-toolbar>
</ion-header>

<ion-content>

  <ion-grid>
    <ion-row>
      <ion-col offset-lg="4" offset-md="3" offset-sm="2" size-sm="8" size-md="6" size-lg="4" class="ion-text-center">

        <app-survey [pricepilot]="pricepilot" [dm]="dm" [dermacenter]="dermacenter"></app-survey>

      </ion-col>

    </ion-row>
  </ion-grid>

 
</ion-content>